module.exports = __webpack_public_path__ + "media/images/flags/1x1/sjm-082afd5e23db0160cf590a85535ac376.svg";